// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
/* tslint:disable */
export const VERSION = {
    "hash": "24439a5918f3cda71871991cebe99f4deae3328b",
    "version": "0.0.0",
    "env": "testing"
};
/* tslint:enable */
